import React from 'react';
import { childrenPropTypes } from '@data-driven-forms/common/prop-types-templates';
import './is-required.css';

var IsRequired = function IsRequired(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "ddorg__ant-component-mapper_is-required",
    "aria-hidden": "true"
  }, "*"), children);
};

IsRequired.propTypes = {
  children: childrenPropTypes
};
export default IsRequired;